import models from './models'
import menu from './menu'
import routes from './routes'

export default {

  name: 'Auth',

  setup () {
    return {
      menu,
      routes
    }
  },

  models () {
    return {
      'auth:user': models.User,
      'auth:client': models.Client,
      'auth:role': models.Role,
      'auth:permission': models.Permission,
      'auth:tos': models.ToS
    }
  }

}
